<div class="d-lg-block d-none">
  <div class="banner justify-content-center" role="banner">
    <h1 class="text-white">{{ 'challenges.page.title' | translate }}</h1>
  </div>
</div>
<div class="d-lg-none">
  <fgb-barcode></fgb-barcode>
</div>

<fgbcl-badge-achieved />

<div class="mt-lg-1 pt-4">
  <fgbcl-scorecard-list-view
    [isSponsorInBody]="false"
    [icon]="'chevron_right'"
    [showPlaceholder]="true"
    class="bg-white"
  ></fgbcl-scorecard-list-view>
</div>
